import clsx from 'clsx';
import LoadingIndicator from '../loading/loadingIndicator';
import * as styles from './button.module.css';

interface IButtonProps {
    text: string,
    onClick: (() => void) | undefined,
    disabled?: boolean,
    variant?: 'outline' | 'text',
    color?: 'success' | 'error' | 'dark' | 'white' | 'falconGray',
    size?: 'tiny' | 'medium' | 'large',
    type?: 'button' | 'submit' | 'reset',
    icon?: React.ElementType,
    loading?: boolean,
}

const Button = ({
    text,
    variant,
    color,
    onClick,
    icon: Icon,
    size = 'medium',
    disabled = false,
    type = 'button',
    loading = false,
}: IButtonProps) => {
    const handleButtonClick = () => {
        if (disabled || !onClick) {
            return;
        }

        onClick();
    };

    return (
        <button
            className={clsx(
                styles.button,
                variant && styles[variant],
                size && styles[size],
                Icon && styles.withIcon,
                color && styles[color],
            )}
            onClick={handleButtonClick}
            disabled={disabled}
            type={type}
        >
            {Icon && (<Icon />)}
            <span className={styles.buttonText}>{text}</span>
            {loading && (<LoadingIndicator size={size}/>)}
        </button>
    );
};

export default Button;
